module.exports = __webpack_public_path__ + "img/10.a28356c3.png";